export const getCorrectFontColor = (text: string) => {
  let setFontColor = 'black'
  if (text !== 'nie oceniono') setFontColor = 'white'
  return {
    color: setFontColor,
  }
}
